'use strict';

module.exports = /* @ngInject */ function ($resource, apiConfig) {
	return {
		addUniteArticle:
			$resource(
				apiConfig.$get().apiUrl + '/unite/article/' +
				':articleId/tobasket' +
				'?quantity=:articleQuantity' +
				'&basket=:basketId' +
				'&customer=:customerId' +
				'&supplier=:supplierCompanyId' +
				'&company_code_id=:companyCodeId' +
				'&company_code=:companyCode',
				{
					articleId: '@articleId',
					articleQuantity: '@articleQuantity',
					basketId: '@basketId',
					customerId: '@customerId',
					supplierCompanyId: '@supplierCompanyId',
					companyCodeId: '@companyCodeId',
					companyCode: '@companyCode'
				}
			),
		getUniteArticleByIndex: $resource(
			apiConfig.$get().apiUrl + '/basketitem/:basket_item_id',
			{
				basket_item_id: '@basket_item_id'
			},
			{
				query: {
					isArray: false,
				},
				update: {
					method: 'PUT',
					data: '@inventory'
				},
			}
		)
	}
}
